import React from 'react'
import { Dropdown } from 'baby-design'
import {
  DropdownOption,
  PaymentMethodDropdownProps,
} from './PaymentMethodDropdown.types'
import { PAYMENT_METHOD_OPTIONS } from './constants'

const PaymentMethodDropdown: React.FC<PaymentMethodDropdownProps> = ({
  onPaymentMethodChanged,
  paymentMethod,
}) => {
  const selectedOption = PAYMENT_METHOD_OPTIONS.find(
    (option: DropdownOption) => option?.value === paymentMethod
  )

  return (
    <Dropdown
      label="Payment method"
      options={PAYMENT_METHOD_OPTIONS}
      placeholder="Optional"
      size="md"
      value={selectedOption}
      onChange={(option) => onPaymentMethodChanged(option?.value || undefined)}
    />
  )
}

export default PaymentMethodDropdown
